import $ from 'jquery';
import * as bootstrap from 'bootstrap';

import flatpickr from "flatpickr";
/*import bootstrap from "bootstrap";*/
//import { Popover, Toast, Modal, Tooltip } from "bootstrap";
import { French } from "flatpickr/dist/l10n/fr";
import { Spanish } from "flatpickr/dist/l10n/es";
import { German } from "flatpickr/dist/l10n/de";


import { MapView } from './map'; // Import direct
import { CookieConsent } from "./cookieConsent";


//import TsIonRangeSlider from 'ts-ion-rangeslider';

import 'select2';
import 'ion-rangeslider';
/*import '../../../node_modules/ion-rangeslider/js/ion.rangeSlider.js';*/


//import 'select2/dist/css/select2.min.css'; // Importez le CSS de Select2
//import '@fortawesome/fontawesome-free/css/all.min.css'; // Importez Font Awesome

// Initialize IonRangeSliders
/*
document.addEventListener('DOMContentLoaded', () => {
    const sliderElements = document.querySelectorAll('.js-range-slider, input[data-ion-rangeslider="true"]');
    sliderElements.forEach(el => {


        const sliderElement = el as HTMLInputElement;
        const id = sliderElement.id;

        const fromInput = document.getElementById(`${id}_from`) as HTMLInputElement;
        const toInput = document.getElementById(`${id}_to`) as HTMLInputElement;


        const options = {
            //...(sliderElement as HTMLElement).dataset,
            type: sliderElement.dataset.type??'double',
            min: parseFloat(sliderElement.dataset.min),
            max: parseFloat(sliderElement.dataset.max),
            from: parseFloat(sliderElement.dataset.from),
            to: parseFloat(sliderElement.dataset.to),
            step: parseFloat(sliderElement.dataset.step),
            grid: sliderElement.dataset.grid === 'true',
            grid_snap: true,            
            drag_interval: true,

            extra_classes: sliderElement.dataset.extraClasses,
            
            onChange: (data) => {
                // Mettre à jour les champs cachés automatiquement                
                if (fromInput) fromInput.value = data.from.toString();
                if (toInput) toInput.value = data.to.toString();

                // Exécuter le callback personnalisé s'il existe
                const onChangeCallback = sliderElement.dataset.onChange;
                if (onChangeCallback && typeof window[onChangeCallback] === 'function') {
                    window[onChangeCallback](data);
                }
            },
            onFinish: (data) => {
                // Exécuter le callback personnalisé s'il existe
                const onFinishCallback = sliderElement.dataset.onFinish;
                if (onFinishCallback && typeof window[onFinishCallback] === 'function') {
                    window[onFinishCallback](data);
                }
            }
        };

        options.from = options.min;
        options.to = options.max;

        //let slider  = new ion.slider(sliderElement,options);
        let slider = $(sliderElement).ionRangeSlider(options);
        //let slider = new  Slider(sliderElement, options);        

        slider.update({ from: parseFloat(fromInput.value), to: parseFloat(toInput.value) });

        var resetBtn = document.querySelector(`.btn-reset-range[data-target='#${id}']`);
        resetBtn.addEventListener('click', function () {
            slider.update({ from: options.min, to: options.max });            
            // Mettre à jour les champs cachés automatiquement            
            if (fromInput) fromInput.value = options.min.toString();
            if (toInput) toInput.value = options.max.toString();
        })        


    });
});
*/


//document.addEventListener('DOMContentLoaded', () => {
//    const sliderElements = document.querySelectorAll('.js-range-slider, input[data-ion-rangeslider="true"]') as NodeListOf<HTMLInputElement>;
//    sliderElements.forEach(sliderElement => {
//        new TsIonRangeSlider.Slider(sliderElement, sliderElement.dataset);
//    });    
     

//});

// fermeture des dropwandown via bouton 
document.addEventListener('click', function (event) {
    // Vérifier si l'élément cliqué a l'attribut data-bs-dismiss="dropdown"
    const dismissButton = (event.target as HTMLElement).closest('[data-bs-dismiss="dropdown"]');
    if (dismissButton) {
        // Trouver le dropdown parent
        const dropdownElement = dismissButton.closest('.dropdown-menu');
        if (dropdownElement) {
            // Fermer le dropdown
            const dropdown = bootstrap.Dropdown.getInstance(dropdownElement.closest('.dropdown').querySelector('[data-bs-toggle="dropdown"]'));
            if (dropdown) {
                dropdown.hide();
            }

            // Exécuter la fonction définie dans data-bs-apply s'il existe
            const applyFunction = dismissButton.getAttribute('data-bs-apply');
            if (applyFunction) {
                try {
                    // Évaluer la fonction (assurez-vous que la fonction existe dans le scope global)
                    const func = window[applyFunction.replace('()', '')];
                    if (typeof func === 'function') {
                        func();
                    } else {
                        console.warn(`La fonction ${applyFunction} n'existe pas`);
                    }
                } catch (error) {
                    console.error(`Erreur lors de l'exécution de ${applyFunction}:`, error);
                }
            }
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {

    $('select[data-select="select2"]').each(function () {
        const $select = $(this);
        console.log('Initialisation de Select2 pour:', $select.attr('id') || $select.attr('class'));
        const selectClasses = $select.attr('class')?.split(/\s+/) || [];
        const applyClasses = $select.data('select2-apply-classes') === true;
        const dataDisableValidFeedback = $select.data('disable-valid-feedback');

        $select.select2({
            templateResult: formatOption,
            templateSelection: formatOption,
            minimumResultsForSearch: Infinity,
            allowClear: false,
            dropdownAutoWidth: true,
            width: '150px',
            selectOnClose: true
        }).on('select2:select', (e) => {

            window['applyFilter']();
        });
    });
    
    function formatOption(option) {
        if (!option.id) {
            return option.text; // Placeholder or empty option
        }
        var icon = $(option.element).data('icon');
        return $('<span class="rounded-5 m-2 text-nowrap"><i class="' + icon + ' me-2"></i>' + option.text + '</span>');
    }
});

// Fonction pour initialiser les composants Bootstrap
export function initBootstrap(): void {
    // Activer les tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(tooltipTriggerEl => {
        new bootstrap.Tooltip(tooltipTriggerEl);
    });

    // Activer les popovers
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    popoverTriggerList.forEach(popoverTriggerEl => {
        new bootstrap.Popover(popoverTriggerEl);
    });
}

// Exporter les composants Bootstrap pour une utilisation spécifique
export {
    Alert,
    Button,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Offcanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip
} from 'bootstrap';

// Exporter Bootstrap dans son ensemble pour une utilisation globale
export default bootstrap;


//export const flatpickr_locale = local;
//window["flatpickr_locale"] = flatpickr_locale;
//window["flatpickr_locale"] = {
//    en: flatpickr.l10ns.default,
//    fr: flatpickr_locale_fr.fr,
//    es: flatpickr_locale_es.es,
//    de: flatpickr_locale_de.de
//};

window["flatpickr_locale"] = {
    en: flatpickr.l10ns.default,
    fr: French,
    es: Spanish,
    de: German
};
//window["bootstrap"] = bootstrap;
window.bootstrap = bootstrap;


//const bootstrap = {    Popover, Modal, Toast}

// Please see documentation at https://learn.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

// Write your JavaScript code.

// <index.d.ts>

HTMLInputElement.prototype.next = function (tagName: string): HTMLInputElement | null {
    let next: HTMLElement | null = this.nextElementSibling;
    while (next && next.tagName !== tagName) {
        next = next.nextElementSibling as HTMLInputElement;
    }
    return next as HTMLInputElement | null;
};

HTMLInputElement.prototype.previous = function (tagName: string): HTMLInputElement | null {
    let previous: HTMLElement | null = this.previousElementSibling;
    while (previous && previous.tagName !== tagName) {
        previous = previous.previousElementSibling as HTMLInputElement;
    }
    return previous as HTMLInputElement | null;
};

export function iif(condition, trueResult, falseResult) {
    if (condition)
        return trueResult;
    else
        return falseResult;
}

export function interpolate(template, params) {
    const replaceTags = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '(': '%28', ')': '%29' };
    const safeInnerHTML = text => text.toString().replace(/[&<>\(\)]/g, tag => replaceTags[tag] || tag);
    const keys = Object.keys(params);
    const keyVals = Object.values(params).map(safeInnerHTML);
    return new Function(...keys, `return \`${template}\``)(...keyVals);
}
function isNullOrWhiteSpace(str) {
    return (!str || /^\s*$/.test(str));
}

function setUrlParams(url, key, value) {
    url = url.split('?');
    var usp = new URLSearchParams(url[1]);
    usp.set(key, value);
    url[1] = usp.toString();
    return url.join('?');
}


function loadModalPage(paramName, paramValue, pageTitle, pageUrl, loadingMessage) {


    function initModalPopup(pageTitle, loadingMessage) {
        $('#modal-page-title').text(pageTitle);
        $('#modal-page-body').empty();
        $('#modal-page').modal('show');

        if (!loadingMessage) loadingMessage = '';
        var spinnerHtml = '<div class="d-flex justify-content-center align-items-center text-body-tertiary">';
        spinnerHtml += '<div class="spinner-border" role="status"></div>';
        spinnerHtml += '<span role="status" class="ms-2">' + loadingMessage + '</span>';
        spinnerHtml += '</div>';

        $('#modal-page-body').append(spinnerHtml);
    }

    initModalPopup(pageTitle, loadingMessage);

    var ajaxUrl = setUrlParams(pageUrl, paramName, paramValue);
    $('#modal-page-body').load(ajaxUrl.toString(), function (response, status, xhr) {
        if (status == 'error') {
            var msg = 'Sorry but there was an error while loading: ' + pageTitle;
            console.log(msg + xhr.status + ' ' + xhr.statusText);
        }
    });
    history.pushState(paramValue, pageTitle, '#' + paramValue + ((pageTitle.length > 0) ? ('&title=' + pageTitle) : ''));
}



function checkModalToOpen(customPageRoute, predefinedPageRoute, loadingMessage) {
    var modalHashPrefix = "#modal-";
    if (window.location.hash && window.location.hash.startsWith(modalHashPrefix)) {
        //remove leading hash char
        /*var hash = window.location.hash.substring(1);*/
        var hash = window.location.hash.replace(modalHashPrefix, '');

        //split hash params
        var hashParams = hash.split('&').reduce(function (array, item) {
            var parts = item.split('=');
            var key = parts[0];
            var value = parts[1];
            if (parts.length == 1) {
                key = 'default';
                value = parts[0];
            }

            array[key] = value;
            return array;
        }, {});

        var popupName = hashParams['default'];
        var popupTitle = hashParams['title'];

        var paramName;
        var popupValue;

        if (!popupTitle) {
            popupTitle = '';
        }

        popupTitle = decodeURI(popupTitle);

        var modalContentRoute;

        if (isGuid(popupName)) {
            paramName = 'pageGuid';
            modalContentRoute = customPageRoute;
        }
        else {
            paramName = 'pageName';
            modalContentRoute = predefinedPageRoute;
        }

        loadModalPage(paramName, popupName, popupTitle, modalContentRoute, loadingMessage);
    }
}

function isGuid(value) {
    var regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
    var match = regex.exec(value);
    return match != null;
}

function printElem(elem) {
    printContent($(elem).html(), 'FAQ');
}

function printContent(data, title) {
    var mywindow = window.open('', title, 'height=400,width=600');
    mywindow.document.write('<html><head><title>' + title + '</title>');
    mywindow.document.write('</head><body>');
    mywindow.document.write(data);
    mywindow.document.write('</body></html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10

    mywindow.print();
    mywindow.close();

    return true;
}

//</Index.d.ts>



var filterAutoSubmitTimeout;
function enableFormAutoSubmit() {
    $('form[data-autosubmit]')
    //Watch change event on forms with "auto-submit" data attribute, its inputs, inputs outside of the form but triggering it with form attr
    $(document).on('change', 'form[data-autosubmit], form[data-autosubmit] :input, [form][data-autosubmit]', function () {

        // Clear the previous timeout, if any
        clearTimeout(filterAutoSubmitTimeout);

        var formId = $(this).attr('form');
        var form;
        if (formId) {
            form = $('#' + formId)
        }
        else {
            // Get the form containing the changed element
            form = $(this).closest('form');
        }

        var delay = form.data('autosubmit-delay') || 500; // Default delay is 500ms
        filterAutoSubmitTimeout = setTimeout(function () {
            // Submit the form
            form.submit();
        }, delay);
    });
}

$(enableFormAutoSubmit);

$(function () {
    function adjustFontSize(container, desiredWidth) {
        var fontSize = parseInt(window.getComputedStyle(container, null).getPropertyValue('font-size'));
        while (container.scrollWidth > desiredWidth && fontSize > 0) {
            fontSize--;
            container.style.fontSize = fontSize + 'px';
        }
    }

    $('.font-fit').each((i, c) => {
        adjustFontSize(c, $(c).parent().css('width'));
    });

    // initialize flatpickr 
    $("[data-toggle=flatpickr]").each(function (i, e) {
        flatpickr(e, $(e).data());
    });


});


////////////////////////////////////////////////////////////////
/// Custom buttons with Radio style associated with tab-pane 
/// Used for radius auto/Custom Range
////////////////////////////////////////////////////////////////

document.addEventListener('DOMContentLoaded', function () {
    const radiosButtons = document.querySelectorAll('button.form-check-input');
    radiosButtons.forEach(b => b.addEventListener('click', function () {
        const _ = this;
        const buttons = document.querySelectorAll('Button[name=' + this.name + ']');
        buttons.forEach(e => {
            const btn = e as HTMLButtonElement;
            const pane = document.querySelector('#' + btn.dataset.tab + '.tab-pane');
            if (btn.id != _.id) {
                //pane.querySelectorAll('input').forEach(i=>i.disabled=true);
                pane.classList.remove('active');
                btn.classList.remove('active');
            } else {
                //pane.querySelectorAll('input').forEach(i=>i.disabled=false);
                pane.classList.add('active');
                btn.classList.add('active');
            }
        });
    }));
});
/*
document.addEventListener("DOMContentLoaded", () => {
    setInterval(() => {
        console.log(screen.orientation.type);
    }, 10000);

    screen.orientation.addEventListener("change", () => {
        console.log("orientation changed");
    })
});

*/


window.blinkError = function (el) {
    const j = $(el);

    j.parent().addClass('input-error');
    j.addClass('input-error');

    setTimeout(function () {
        j.parent().removeClass('input-error');
        j.removeClass('input-error');
    }, 2000);
}

export class Loader {
    private _spinner: string = "<div class=\"spinner-border\" role=\"status\"><span class=\"visually-hidden\" > Loading...</span></div>";
    private _element: HTMLElement | JQuery<HTMLElement>;
    private _spinnerElem: HTMLElement | JQuery<HTMLElement>;
    constructor(elem: HTMLElement | JQuery<HTMLElement>) {
        this._element = elem;
    }

    public Show() {
        this._spinnerElem = $(this._spinner);
        const toa = new bootstrap.Toast("body");
        toa.show();

        this._spinnerElem.appendTo(this._element).appendTo(this._element);
    }
    public Hide() {
        this._spinnerElem.remove();
    }
}

export function initializePopovers() {
    // Sélectionner tous les éléments avec data-bs-toggle="popover"
    const popoverElements = document.querySelectorAll('[data-bs-toggle="popover"]');

    // Initialiser le popover pour chaque élément
    popoverElements.forEach(function (element) {
        new bootstrap.Popover(element, {
            trigger: 'hover', // Déclencher au survol
            placement: 'top', // Position du popover
            html: true // Permettre du contenu HTML (facultatif)
        });
    });
}


document.addEventListener('DOMContentLoaded', function () {

    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl, { trigger: "click hover focus" }))

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

});


window["contactForm"] = {
    onBegin: function () {
        console.log("contactForm.onBegin");
        $('#ContactUs').find('.modal-footer').find('.alert').hide();
        $('#ContactUs').find('input[type=submit]').prop('disabled', true).addClass('disabled');
    },
    onSuccess: function () {
        console.log("contactForm.onSuccess");
        bootstrap.Modal.getInstance('#ContactUs').hide();
        //new Modal('#ContactUs').hide();
        new bootstrap.Toast($('#ContactUsSendResult').find('.toast')[0]).show();//.toast('show');
    },
    onFailure: function () {
        console.log("contactForm.onFailure");
        $('#ContactUs').find('.modal-footer').find('.alert').show();
    },
    onComplet: function () {
        console.log("contactForm.onComplet");
        $('#ContactUs').find('input[type=submit]').prop('disabled', false).removeClass('disabled');
    },
    modal: function () {
        contactUs();
    }
};

// non utilisé car malheureusement et pour une raison inconnu la validation unobstructive ne fonctionne pas quand on charge cette modal en ajax 

async function contactUs(): Promise<bootstrap.Modal> {

    return new Promise<bootstrap.Modal>((resolve, reject) => {

        fetch(`/${document.documentElement.lang}/home/ContactUs`, {
            method: "GET",
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then(response => {
            if (!response.ok) throw new Error('Erreur réseau');
            return response.text();
        })
            .then(data => {

                // Injecter le contenu de la modale dans le conteneur
                $("#modalContainer").append($(data));

                const modalContactUs = bootstrap.Modal.getOrCreateInstance("#ContactUs");

                var form = $("#ContactUs").find("form").removeData('validator').removeData('unobtrusiveValidation');

                $.validator.unobtrusive.parse(form); // Réappliquer la validation

                modalContactUs.show();

                resolve(modalContactUs);
            })
            .catch(error => {
                 
                console.error('Erreur lors du chargement de la partial:', error);

                new bootstrap.Toast(`<div class="toast" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body">Erreur de chargement</div></div>`).show();
                reject();
                //conteneur.innerHTML = '<p>Erreur de chargement</p>';
            });

        // Supprimer la modale du DOM après sa fermeture pour éviter les duplications
        $(document).on('hidden.bs.modal', '#ContactUs', function () {
            $(this).remove();
        });
    });
}
window["contactUs"] = contactUs;

